<script setup>
import { User, getFullName } from '@pfsc/core/models/user';
import { Package } from '@pfsc/core/models/package';
import { useAuthStore } from '@pfsc/core/stores/auth.store';
import { redirectUtils } from '@pfsc/core/utils/redirect';
import { computed } from 'vue';

const props = defineProps({
  learner: {
    type: User,
    required: true,
  },

  package: {
    type: [Package, Object],
    required: true,
  },

  // To open tab correctly after redirecting
  toTab: {
    type: String,
    required: false,
  },
});

const authStore = useAuthStore();

// const isFromNewSystem = computed(() => isRegistrationFromNewSystem(props.package));

/** Attach link when user is admin or admin is on admin dashboard */
const shouldAttachLink = computed(() => {
  const isAdminViewingLearnerDetail = authStore.groupAdmin != null && authStore.learner != null;
  return isAdminViewingLearnerDetail === false && authStore?.currentUser?.isStudent === false;
});

const learnerFullName = computed(() => getFullName(props.learner));

</script>

<template>
  <router-link
    v-if="shouldAttachLink"
    class="highlight"
    title="View"
    :to="redirectUtils.getStudentDetailUrl(authStore.currentUser, learner, toTab, null)"
  >
    {{ learnerFullName }}
  </router-link>
  <span v-else>
    {{ learnerFullName }}
  </span>
</template>
